<div class="errorWrapper">
  <ng-container *ngFor="let error of errors">
    <mat-icon>error</mat-icon>
    <div class="errorDescription">
      {{error}}
    </div>
  </ng-container>
</div>
